import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getIncomeTypeList = createAsyncThunk(
  "get-income-type",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("income-type/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createIncomeType = createAsyncThunk(
  "create-income-type",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("income-type", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editIncomeType = createAsyncThunk(
  "edit-income-type",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`income-type/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateIncomeType = createAsyncThunk(
  "update-income-type",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/income-type/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteIncomeType = createAsyncThunk(
  "delete-income-type",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/income-type/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const incomeTypeSlice = createSlice({
  name: "incomeType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIncomeTypeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIncomeTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.incomeTypeList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getIncomeTypeList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default incomeTypeSlice.reducer;
